export const BUTTON_VARIANTS = {
  CONTAINED: 'contained',
  TEXT: 'text',
  OUTLINED: 'outlined',
  ICON: 'icon',
  BOX: 'box',
}

export const BUTTON_THEME = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  GRAY: 'gray',
  GREEN: 'green',
}
export const BUTTON_SIZE = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
}
